import PropTypes from 'prop-types'
import { Button } from '@context365/button'
import { Input, Select } from '@context365/forms'
import { RemoveCircleOutline } from '@context365/icons'
import { Form } from 'antd'
import DateField from './DateField'
import LabelField from './LabelField'

const DealField = ({
  value,
  errors = {},
  onChange,
  addItem,
  showAdd,
  showRemove,
  removeItem,
  securityTypeOptions,
  dealLeadStatusOptions,
  listNumber,
}) => {
  const handleChange = (field, val) => {
    onChange({ ...value, [field]: val })
  }

  return (
    <>
      <div>
        <div className="flex justify-between">
          <div className="type-body-semibold-md">Deal #{listNumber}</div>
          {showRemove && (
            <div className="hidden md:flex">
              <Button
                variant="outlined"
                status="error"
                iconLeft={<RemoveCircleOutline />}
                onClick={() => removeItem()}
              >
                Remove Deal
              </Button>
            </div>
          )}
        </div>
        <div className="Question-row mb-2">
          <span className="Question-col" style={{ paddingRight: '10px' }}>
            <Input
              label="Name"
              name="name"
              required
              value={value.name}
              helpMessage="e.g. Starwood Hotels"
              errorMessage={errors.name}
              onChange={(e) => handleChange('name', e.target.value)}
            />
          </span>
          <span className="Question-col" style={{ paddingLeft: '10px' }}>
            <Select
              label="Security Type"
              name="securityTypeId"
              value={value.securityTypeId}
              onChange={(val) => handleChange('securityTypeId', val)}
              errorMessage={errors.securityTypeId}
              helpMessage="e.g. Equity"
              required
            >
              {securityTypeOptions.map((option) => (
                <Select.Option
                  key={option.id}
                  className="py-2"
                  value={option.id}
                >
                  {option.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        </div>
        <div className="Question-row">
          <span className="Question-col" style={{ paddingRight: '10px' }}>
            <Form.Item
              style={{ marginBottom: 0 }}
              validateStatus={errors.investmentDate ? 'error' : 'success'}
              help={
                errors.investmentDate &&
                typeof errors.investmentDate === 'string'
                  ? errors.investmentDate
                  : ''
              }
            >
              <LabelField title="Investment Date" isRequired />
              <DateField
                name="investmentDate"
                value={value.investmentDate}
                setFieldValue={(name, val) => handleChange(name, val)}
              />
            </Form.Item>
          </span>
          <span className="Question-col" style={{ paddingLeft: '10px' }}>
            <Select
              label="Status"
              name="dealLeadStatusId"
              value={value.dealLeadStatusId}
              onChange={(val) => handleChange('dealLeadStatusId', val)}
              errorMessage={errors.dealLeadStatusId}
              required
            >
              {dealLeadStatusOptions.map((option) => (
                <Select.Option
                  key={option.id}
                  className="py-2"
                  value={option.id}
                >
                  {option.name}
                </Select.Option>
              ))}
            </Select>
          </span>
        </div>
      </div>
      {showRemove && (
        <div className="md:hidden mb-8">
          <Button
            className="w-full"
            variant="outlined"
            status="error"
            iconLeft={<RemoveCircleOutline />}
            onClick={() => removeItem()}
          >
            Remove Deal
          </Button>
        </div>
      )}
      {showAdd && (
        <div>
          <Button variant="link" onClick={() => addItem()}>
            + Add Deal
          </Button>
        </div>
      )}
    </>
  )
}

DealField.propTypes = {
  value: PropTypes.string,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  addItem: PropTypes.func,
  showAdd: PropTypes.bool,
  showRemove: PropTypes.bool,
  removeItem: PropTypes.func,
  securityTypeOptions: PropTypes.array,
  dealLeadStatusOptions: PropTypes.array,
  listNumber: PropTypes.number.isRequired,
}

export default DealField
